/* The URL path segment for the SharePoint "Shared Documents" library */ export const SharedDocumentFolderName = "/Shared Documents/";
/**
 * URL parameter constants
 */ export const URL_PARAMS = {
    WEB: "web"
};
/**
 * URL parameter value constants
 */ export const URL_PARAM_VALUES = {
    ENABLED: "1"
};
/** The Folder Name for the Copilot (PMA) folder, used in SPO-based PMA plans. */ export const CopilotFolderName = "Copilot";
/** The Folder Name for the Status Reports folder. */ export const StatusReportsFolderName = "Status Reports";
/**
 * The Folder Name for the Microsoft Planner folder, at the root of the SharePoint site's drive, used for SPO-based
 * PMA plans and Status Reports.
 */ export const PlannerFolderName = "Microsoft Planner";
/** The prefix for HTTPS URLs */ export const httpsPrefix = "https://";
